import React, { useRef, useEffect } from "react";
import * as d3 from 'd3';
import { select } from 'd3';
import axios from 'axios';
import { useQuery } from 'react-query';

const fetchData = async (statKey) => {
    const { data } = await axios.get(`${process.env.REACT_APP_API_HOST}/bc/svc/2${statKey}`);
    return data;
}

function DataContainerSite(props) {
    const { TableAreaName, Color, menu, InvestigationType } = props;
    // const { data, error, isError, isLoading } = useQuery('dataSite', fetchData);
    const { data, error, isError, isLoading } = useQuery(['dataSite', menu], () => fetchData(menu));

    var regex = /[a-z0-9]|[ \[\]{}()<>?|`~!@#$%^&*-_+=,.;:\"'\\]/g;
    // const areaName = TableAreaName.replace(regex, '')
    const areaName = TableAreaName.replace(' ', '')

    const svgRef = useRef(null);


    const tcolor = Color, grey = '#DDD';
    const divWidth = 500, divHeight = 200;
    const margin = { w: 25, h: 25 }, axisMargin = { x: 0, y: 10 }, chartTitleMargin = 20;
    const lw = 1, ms = 5;

    function preprocess(d, val = "anals_value", dateVal = "year") {
        // console.log('d --', d)
        // console.log('--------------------')
        let NaN_years = ['2017','2018','2019','2020','2021','2022','2023','2024']  // 데이터 없어도 표시되어야 하는 년도 목록

        for (let i of d) {
            i.value = +i[val] || NaN;
            if (dateVal) {
                // console.log(i[dateVal])

                let year ;
                if (typeof(i[dateVal]) == 'object') { 
                    year = String(i[dateVal].getFullYear()) 
                } else  {
                    year = i[dateVal] 
                    i[dateVal] = new Date(i[dateVal], 0);
                }
                
                NaN_years = NaN_years.filter((element) => element !== year);
            }
        }
        // console.log(d)
        // console.log('NaN', NaN_years)

        for (let y of NaN_years) {
            d.push({
                "year": new Date(y, 0),
                "value": NaN
            })
        }

        return d;
    }

    const shadeColor = (color, percent) => {
        var R = parseInt(color.substring(1, 3), 16);
        var G = parseInt(color.substring(3, 5), 16);
        var B = parseInt(color.substring(5, 7), 16);

        R = parseInt((R * (100 + percent)) / 100);
        G = parseInt((G * (100 + percent)) / 100);
        B = parseInt((B * (100 + percent)) / 100);

        R = R < 255 ? R : 255;
        G = G < 255 ? G : 255;
        B = B < 255 ? B : 255;

        var RR =
            R.toString(16).length === 1 ? "0" + R.toString(16) : R.toString(16);
        var GG =
            G.toString(16).length === 1 ? "0" + G.toString(16) : G.toString(16);
        var BB =
            B.toString(16).length === 1 ? "0" + B.toString(16) : B.toString(16);

        // console.log('#' + RR + GG + BB, 'result');
        // setDarkenColor("#" + RR + GG + BB, "result");
        return "#" + RR + GG + BB;
    };

    function renderChartTs(data_, svg) {
        // console.log("data_");
        // console.log(data_);
        // console.log(areaName);
        // const rdata = preprocess(data_.filter(x => x.sitename == areaName), "mgc"); // what if sdname doesn't exist?
        // console.log('----------------------------------------')
        // console.log(areaName, ' data_ -- ' ,data_.filter(x => x.sitename == areaName))
        const rdata = preprocess(data_.filter(x => x.sitename == areaName), "anals_value");
        // console.log(rdata);
        const box = { w: divWidth - margin.w * 2, h: divHeight - margin.h * 2 - chartTitleMargin };

        const yScale = d3.scaleLinear()
            .domain(d3.extent(rdata, d => d.value)).nice()
            .range([box.h - axisMargin.y, axisMargin.y + chartTitleMargin]);

        const xScale = d3.scaleTime()
            .domain(d3.extent(rdata, d => d.year))
            .range([axisMargin.x, box.w - axisMargin.x]);

        if(InvestigationType === '퇴적물'){
            svg.insert('text')
            .text("'" + areaName + "' 토양유기탄소저장량(Mg C ha⁻¹)")
            .attr('class', 'chartTitle')
            .attr('y', chartTitleMargin);
        } else if(InvestigationType === '염습지'){
            svg.insert('text')
            .text("'" + areaName + "' 토양유기탄소농도(%)")
            .attr('class', 'chartTitle')
            .attr('y', chartTitleMargin);
        } else if(InvestigationType === '해초대'){
            svg.insert('text')
            .text("'" + areaName + "' 토양유기탄소함량(%)")
            .attr('class', 'chartTitle')
            .attr('y', chartTitleMargin);
        }

        const DataArray = rdata.filter((element) => !isNaN(element.value));
        // console.log('DataArray',DataArray)
        // console.log('DataArray.length', DataArray.length)
        if ( DataArray.length === 0 ){
            svg.insert('text')
                .text('데이터 없음')
                .attr('class', 'noData')
                .attr('x', box.w/2 )
                .attr('text-anchor', 'start')
                .attr('y', box.h/2 + axisMargin.y )
                .attr('dominant-baseline', 'central')
                .style('fill', 'darkGrey');
        } else {
            svg.selectAll("noData").remove();
        }

        let chart = svg.append('g')
            .attr('transform', `translate(${margin.w}, ${margin.h})`);

        // console.log('rdata',rdata)

        chart.append('path')
            .datum(rdata)
            .attr('fill', 'none')
            .attr('stroke', tcolor)
            .attr('stroke-width', lw)
            .attr('marker-start', 'url(#dot)')
            .attr('marker-mid', 'url(#dot)')
            .attr('marker-end', 'url(#dot)')
            .attr('stroke-linecap', 'round')
            .attr('d', d3.line()
                .defined(d => !isNaN(d.value))
                .x(d => xScale(d.year))
                .y(d => yScale(d.value)));

        chart.append('g')
            .selectAll('text')
            .data(rdata)
            .join('text')
            .text(d => !isNaN(d.value) ? parseInt(d.value) : '')
            // .attr('fill', (d, i) => {
            //     const val = 50 - (.25 + (i / 2) * .75) * 100;
            //     const resultColor = shadeColor(tcolor, val);
            //     return resultColor;
            // })
            .attr('fill', tcolor)
            .attr('x', d => xScale(d.year))
            .attr('y', d => yScale(d.value))
            .attr('dy', -10)
            .attr('text-anchor', 'middle');

        // chart.append('g')
        //     // .attr('transform', `translate(${axisMargin}, 0)`)
        //     .attr('id', 'y')
        //     .attr('class', 'scale')
        //     .call(d3.axisLeft(yScale)
        //         .ticks(4)
        //         .tickFormat(d3.format('.0f'))
        //     );

        chart.append('g')
            .attr('transform', `translate(0, ${box.h})`)
            .attr('id', 'x')
            .attr('class', 'scale')
            .call(d3.axisBottom(xScale)
                .ticks(d3.timeYear.every(1))
                .tickSize(0)
                .tickPadding(5)
            );
        return chart;
    }

    useEffect(() => {
        const svg = select(svgRef.current); // selection 객체

        svg.selectAll('*').remove() //이전 svg 제거

        if (data && data !== undefined) {
            // console.log('useEffect svg')
            // console.log(data)
            svg
                .attr('width', divWidth)
                .attr('height', divHeight)
                .attr('color', grey)
                .append('defs')
                .append('marker')
                .attr('id', 'dot')
                .attr('markerUnits', 'userSpaceOnUse')
                .attr('viewBox', [0, 0, (ms + lw) * 2, (ms + lw) * 2])
                .attr('refX', ms + lw)
                .attr('refY', ms + lw)
                .attr('markerWidth', ms + lw)
                .attr('markerHeight', ms + lw)
                .append('circle')
                .attr('cx', ms + lw)
                .attr('cy', ms + lw)
                .attr('r', ms)
                .style('stroke', tcolor)
                .attr('stroke-width', lw * 3)
                .style('fill', tcolor);
            renderChartTs(data, svg);
        }
    }, [data, menu, areaName]); //data 변경시 렌더링함.

    if (isLoading) {
        return <div>Loading...</div>
    }
    if (isError) {
        return <div>Error! {error.message}</div>
    }

    return (
        <>
            <svg ref={svgRef}></svg>
        </>
    );
}

export default DataContainerSite;